// export const SIGNIN_PATH = '/auth/signin';
export const STATUS = {
    ACTIVE: 'active',
    CONFIRMED: 'confirmed'
};